// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__37b2Y","info":"Note_info__3YiZz","note":"Note_note__1-wIV","actions":"Note_actions__36PSE"};